module.exports = __webpack_public_path__ + "53c51672a7e186a75406d32e5753b6f9.svg";